module.exports = __webpack_public_path__ + "img/plus_grey.2b6c8480.svg";